import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterTextPlainValue,
  UniversalFilterTextPlainOnChange
} from './UniversalFilterTextPlain.types';

import { useUniversalFilterTextPlain } from './hooks/useUniversalFilterTextPlain';

import { UniversalFilterTextInput } from '../../helpers/UniversalFilterTextInput';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterTextPlainProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterTextPlainValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterTextPlainOnChange;
}

function UniversalFilterTextPlain({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterTextPlainProps) {
  const { filterState, handleTextChange } = useUniversalFilterTextPlain({
    filterStateCacheKey,
    filterValue,
    onChange
  });

  return (
    <UniversalFilterTemplate filterView={filterView} i18nName={i18nName}>
      <UniversalFilterTextInput
        value={filterState.text}
        autoFocus={autoFocus}
        onChange={handleTextChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterTextPlain;
